import(/* webpackMode: "eager" */ "/vercel/path0/src/app/for_you/curiosity/page.tsx");
